<template>
  <div v-if="sellingPoints.length" class="space-y-2 3xl:space-y-4 3xl:py-3">
    <div
      v-for="(sellingPoint, index) in sellingPoints"
      :key="index"
      class="flex items-center"
    >
      <IconUiCheckmark class="mr-2 inline-block size-3 flex-none text-green" />
      <span class="text-sm">
        {{ sellingPoint }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Product } from '@scayle/storefront-nuxt'
import { getAdvancedAttributeFirstValue } from '#layers/base/utils/advancedAttribute'

const props = defineProps({
  product: {
    type: Object as PropType<Product>,
    required: true,
  },
})

const sellingPoints = computed(() => {
  if (!props.product) {
    return []
  }

  const keys = [
    'sellingPoint1Dessin',
    'sellingPoint2Material',
    'sellingPoint3AGSSpezialDetail',
    'sellingPoint4InternEinkauf',
  ]

  return keys.reduce((acc, key) => {
    const value = getAdvancedAttributeFirstValue(props.product, key) as string
    if (value) {
      acc.push(value)
    }
    return acc
  }, [] as string[])
})
</script>
